export const BASE_URL = 'https://host03pet.nexopet.com/api/v1.0';
export const BASE_IMG_URL = 'https://host03pet.nexopet.com/';

// export const BASE_URL = 'https://mhfemu.pythonanywhere.com/api/v1.0';
// export const BASE_IMG_URL = 'https://mhfemu.pythonanywhere.com/';
